
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsed6e7176d3d3627a571cd5516ae3e0b1en from './en.yaml'
            i18n.addResourceBundle('en', 'ed6e7176d3d3627a571cd5516ae3e0b1', flattenObject(nsed6e7176d3d3627a571cd5516ae3e0b1en), true, true);
        
        export default 'ed6e7176d3d3627a571cd5516ae3e0b1';
    